export function getSlideTransformEl(slideEl) {
  return (
    slideEl.querySelector(".swiper-slide-transform") ||
    (slideEl.shadowEl && slideEl.shadowEl.querySelector(".swiper-slide-transform")) ||
    slideEl
  );
}
